import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}/Driver`;

export const fetchDrivers = async (branchId) => {
  const url = branchId ? `${API_BASE_URL}/all?branchId=${branchId}` : `${API_BASE_URL}/all`;
  const response = await axios.get(url);
  return response.data;
};

export const fetchDriverById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const registerDriver = async (driverData) => {
  const response = await axios.post(`${API_BASE_URL}/register`, driverData);
  return response.data;
};

export const updateDriver = async (id, driverData) => {
  const response = await axios.put(`${API_BASE_URL}/${id}`, driverData);
  return response.data;
};

export const deleteDriver = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const resetDriverPassword = async (id, newPassword) => {
  const response = await axios.put(`${API_BASE_URL}/ResetPassword/${id}`, { NewPassword: newPassword });
  return response.data;
};
